import requestCore from '@/utils/requestCore'

// 查询积分商品列表
export function listIntegralcommodity(query) {
    return requestCore({
        url: '/application/integralcommodity/list',
        method: 'get',
        params: query
    })
}

// 取消微信订单
export function cancelWxQRCode(orderNo) {
    return requestCore({
        url: '/application/api/wx-pay/cancel/'+ orderNo,
        method: 'post'
    })
}

// 购买二维码
export function getIntegralcommodityWxQRCode(id) {
    return requestCore({
        url: '/application/api/wx-pay/native/'+ id,
        method: 'post'
    })
}

// 轮询微信支付结果
export function getWxQRCodeStatus(orderNo) {
    return requestCore({
        url: '/application/integralorder/orderStatus/'+ orderNo,
        method: 'get'
    })
}